import '@fontsource/roboto/300.css'
import '@fontsource/roboto/400.css'
import '@fontsource/roboto/500.css'
import '@fontsource/roboto/700.css'
// @ts-expect-error roboto300
import roboto300 from '@fontsource/roboto/files/roboto-latin-300-normal.woff2'
// @ts-expect-error roboto400
import roboto400 from '@fontsource/roboto/files/roboto-latin-400-normal.woff2'
// @ts-expect-error roboto500
import roboto500 from '@fontsource/roboto/files/roboto-latin-500-normal.woff2'
// @ts-expect-error roboto700
import roboto700 from '@fontsource/roboto/files/roboto-latin-700-normal.woff2'

const font300Element = document.createElement('link')
font300Element.rel = 'preload'
font300Element.as = 'font'
font300Element.type = 'font/woff2'
font300Element.crossOrigin = ''
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
font300Element.href = roboto300

document.head.appendChild(font300Element)
const font400Element = document.createElement('link')
font400Element.rel = 'preload'
font400Element.as = 'font'
font400Element.type = 'font/woff2'
font400Element.crossOrigin = ''
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
font400Element.href = roboto400

document.head.appendChild(font400Element)

const font500Element = document.createElement('link')
font500Element.rel = 'preload'
font500Element.as = 'font'
font500Element.type = 'font/woff2'
font500Element.crossOrigin = ''
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
font500Element.href = roboto500

document.head.appendChild(font500Element)

const font700Element = document.createElement('link')
font700Element.rel = 'preload'
font700Element.as = 'font'
font700Element.type = 'font/woff2'
font700Element.crossOrigin = ''
// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
font700Element.href = roboto700

document.head.appendChild(font700Element)
